import { ReactElement, ReactNode } from 'react';
import CustomAlert from '../CustomAlert/CustomAlert';
import CustomTab from '../CustomTab/CustomTab';
import BasicTab from '../BasicTab/BasicTab';
import { Box } from '@mui/material';
import CustomHeadline from '../CustomHeadline/CustomHeadline';
import zeplinColor from '../../../theme/Color';
import CustomAlertContain from '../CustomAlert/CustomAlertContain';

const CustomHomepage = ({
  sportsData,
  ProfileDetails,
  DealCard,
  DashboardTabs,
  handleChange,
  value,
  alert,
  handleClose,
  Children,
  customHeader,
  CTA,
  basicTab,
}: {
  sportsData: any;
  ProfileDetails?: ReactElement;
  DealCard?: ReactElement;
  DashboardTabs: any;
  handleChange: any;
  value: any;
  alert: any;
  handleClose: any;
  Children?: ReactNode;
  customHeader?: ReactElement;
  CTA?: JSX.Element;
  basicTab?: boolean;
}) => {
  const today = new Date();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ position: 'sticky', top: 0 }}>
        {sportsData?.length ? (
          <Box>
            <CustomHeadline sportsData={sportsData} />
          </Box>
        ) : (
          ''
        )}
        {customHeader ? (
          <>{customHeader}</>
        ) : (
          <Box
            sx={{
              top: '16px',
              backgroundColor: zeplinColor.BasicBlack,
              color: zeplinColor.Neutral1,
              // display: 'inline',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '16px 24px',
              gap: '29px',
              // flex: 1,
              // height: '140px',
            }}
          >
            {ProfileDetails}
            {DealCard}
          </Box>
        )}
      </Box>

      <Box
        sx={{
          padding: { xs: '20px 16px 0rem 16px', xl: '24px 1.5rem 0rem 1.5rem' },
          flexGrow: 1,
          // overflowY: 'auto',
          // height: '75vh',
          display: 'flex',
          flexDirection: 'column',
          position: 'relative',
          flex: 1,
          // position: 'relative',
        }}
      >
        {basicTab ? (
          <BasicTab tabs={DashboardTabs} handleChange={handleChange} value={value} />
        ) : (
          <CustomTab tabs={DashboardTabs} handleChange={handleChange} value={value} />
        )}
        {CTA && (
          <Box
            sx={{
              position: 'absolute',
              top: { xs: '20px', xl: '24px' },
              right: { xs: '16px', xl: '1.5rem' },
            }}
          >
            {CTA}
          </Box>
        )}
      </Box>

      <CustomAlert
        open={alert ? true : false}
        handleClose={handleClose}
        message={
          <CustomAlertContain
            alertIcon={
              !alert?.includes('successful') ? (
                <img src='/assets/error.svg' width={24} height={24} />
              ) : (
                <img src='/assets/checkmark-green.png' width={24} height={24} />
              )
            }
            alert={alert}
            error={!alert?.includes('successful') ? true : false}
          />
        }
        error={!alert?.includes('successful') ? true : false}
      />
      {Children}
    </Box>
  );
};

export default CustomHomepage;
